import { call, put, delay, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actions, { Types } from '~/store/ducks/customers';
import snackbar from '../ducks/snackbar';
import api from '~/services/api';

function* loadCustomers({ partner }) {
  try {
    const { data } = yield call(api.get, `/v1/partners/${partner}/customers`);
    yield put(actions.loadCustomersSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadCustomer({ partner, customer }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/customers/${customer}`
    );
    yield put(actions.loadCustomerSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* updateCustomer({ partner, customer, data }) {
  try {
    yield call(api.put, `/v1/partners/${partner}/customers/${customer}`, data);

    yield put(actions.updateCustomerSuccess());

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'customer.update.success'
      })
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* addCustomer({ partner, customer, data }) {
  try {
    const res = yield call(api.post, `/v1/partners/${partner}/customers`, data);

    yield put(actions.addCustomerSuccess());

    if (res.data) {
      yield put(
        snackbar.showSnackbar({
          color: 'success',
          icon: 'check',
          text: 'customer.add.success'
        })
      );

      yield put(push(`/invoices/clients/details/${res.data.id}`));

      yield delay(5000);
      yield put(snackbar.hideSnackbar());
    }
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* removeCustomer({ partner, customer }) {
  try {
    yield call(api.put, `/v1/partners/${partner}/customers/${customer}`);

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'customers.remove.success'
      })
    );

    yield put(push(`/v1/partners/${partner}/customers`));

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch {
    yield put(
      snackbar.showSnackbar({
        color: 'danger',
        icon: 'alert-circle',
        text: 'customers.remove.error'
      })
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  }
}

const sagas = [
  takeLatest(Types.LOAD_CUSTOMERS, loadCustomers),
  takeLatest(Types.LOAD_CUSTOMER, loadCustomer),
  takeLatest(Types.UPDATE_CUSTOMER, updateCustomer),
  takeLatest(Types.ADD_CUSTOMER, addCustomer),
  takeLatest(Types.REMOVE_CUSTOMER, removeCustomer)
];

export default sagas;
